export default "__VITE_ASSET__BT2DCwP2__"